import { render, staticRenderFns } from "./permissions-list.vue?vue&type=template&id=793cef74&scoped=true"
import script from "./permissions-list.vue?vue&type=script&lang=js"
export * from "./permissions-list.vue?vue&type=script&lang=js"
import style0 from "./permissions-list.vue?vue&type=style&index=0&id=793cef74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793cef74",
  null
  
)

export default component.exports